module.exports = __webpack_public_path__ + "static/media/tache_bg.4d0d2d89.svg";